'use client';

import { SVGProps } from 'react';

export const EyeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="22" height="16" />
      <g id="Input">
        <rect x="-684" y="-643" width="1489" height="1384" rx="20" />
        <rect
          x="-683.5"
          y="-642.5"
          width="1488"
          height="1383"
          rx="19.5"
          stroke="white"
          strokeOpacity="0.1"
        />
        <g id="input-search">
          <rect
            x="-414.5"
            y="-376.5"
            width="475"
            height="1006"
            rx="4.5"
            stroke="#9747FF"
            strokeDasharray="10 5"
          />
          <g id="Dark Mode=False, State=Show password">
            <rect x="-394.5" y="-18.5" width="435" height="53" rx="15.5" />
            <rect x="-394.5" y="-18.5" width="435" height="53" rx="15.5" />
            <g id="Eye">
              <g id="Eye_2">
                <g id="Vector">
                  <path
                    d="M14 8C14 9.65685 12.6569 11 11 11C9.34314 11 8 9.65685 8 8C8 6.34315 9.34314 5 11 5C12.6569 5 14 6.34315 14 8Z"
                    stroke="var(--textAndLabels-main)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1 8C2.60014 3.90264 6.33603 1 11 1C15.664 1 19.3999 3.90264 21 8C19.3999 12.0974 15.664 15 11 15C6.33603 15 2.60014 12.0974 1 8Z"
                    stroke="var(--textAndLabels-main)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EyeOffIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.73023 2.07319C10.1449 2.02485 10.5685 2 11 2C15.664 2 19.3999 4.90264 21 9C20.6054 10.0104 20.0809 10.9482 19.4447 11.7877M5.51962 3.51944C3.47955 4.76406 1.90111 6.69259 1 9C2.60014 13.0974 6.33603 16 11 16C13.0376 16 14.898 15.446 16.4806 14.4804M8.87877 6.87859C8.33582 7.42149 8 8.17153 8 9C8 10.6569 9.34314 12 11 12C11.8285 12 12.5785 11.6642 13.1214 11.1212"
        stroke="var(--textAndLabels-main)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 1L19 17"
        stroke="var(--textAndLabels-main)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const GlobeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 1C17.0232 1 21.5 5.47676 21.5 11C21.5 16.5232 17.0232 21 11.5 21C5.97676 21 1.5 16.5232 1.5 11C1.5 5.47676 5.97676 1 11.5 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4976 1C13.5538 1 15.2197 5.47676 15.2197 11C15.2197 16.5232 13.5538 21 11.4976 21C9.44138 21 7.77539 16.5232 7.77539 11C7.77539 5.47676 9.44138 1 11.4976 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 10.9982C21.5 13.0545 17.0232 14.7204 11.5 14.7204C5.97676 14.7204 1.5 13.0545 1.5 10.9982C1.5 8.94202 5.97676 7.27606 11.5 7.27606C17.0232 7.27606 21.5 8.94202 21.5 10.9982Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropdownArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.52353 0.5L0.5 1.5201L6.5 7.5L12.5 1.5201L11.4765 0.5L6.5 5.4598L1.52353 0.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SunIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10"
      cy="10.5"
      r="4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    {[
      { d: 'M18 10.5H19' },
      { d: 'M1 10.5H2' },
      { d: 'M10 18.5L10 19.5' },
      { d: 'M10 1.5L10 2.5' },
      { d: 'M15.6562 16.1569L16.3634 16.864' },
      { d: 'M3.63672 4.13599L4.34383 4.84309' },
      { d: 'M4.34375 16.1569L3.63664 16.864' },
      { d: 'M16.3633 4.13599L15.6562 4.84309' }
    ].map((pathProps, index) => (
      <path
        key={index}
        d={pathProps.d}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    ))}
  </svg>
);

export const MoonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5 10.776L20.4993 10.8127C20.5152 10.3799 20.2507 9.98608 19.8441 9.83707C19.4374 9.68806 18.9811 9.81775 18.7136 10.1583L19.5 10.776ZM8.9753 1.5L9.6958 2.19346C9.99549 1.88208 10.0612 1.41342 9.85882 1.0316C9.65639 0.649771 9.23158 0.441186 8.80568 0.514491L8.9753 1.5ZM18.7136 10.1583C17.6115 11.5615 15.9111 12.4567 14.0044 12.4567V14.4567C16.5539 14.4567 18.8235 13.2563 20.2864 11.3937L18.7136 10.1583ZM14.0044 12.4567C10.6958 12.4567 8.00195 9.75421 8.00195 6.40611H6.00195C6.00195 10.8458 9.57832 14.4567 14.0044 14.4567V12.4567ZM8.00195 6.40611C8.00195 4.76711 8.64707 3.28309 9.6958 2.19346L8.2548 0.806544C6.86053 2.25519 6.00195 4.23132 6.00195 6.40611H8.00195ZM2.5 10.435C2.5 6.44305 5.37684 3.13406 9.14493 2.48551L8.80568 0.514491C4.08455 1.32708 0.5 5.46277 0.5 10.435H2.5ZM10.5031 18.5C6.08957 18.5 2.5 14.8957 2.5 10.435H0.5C0.5 15.9873 4.97211 20.5 10.5031 20.5V18.5ZM18.5007 10.7393C18.342 15.0583 14.8159 18.5 10.5031 18.5V20.5C15.9081 20.5 20.3018 16.1907 20.4993 10.8127L18.5007 10.7393Z"
      fill="currentColor"
    />
  </svg>
);

export const CrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Shape"
      d="M20 1.73892L18.2611 0L10 8.26108L1.73892 0L0 1.73892L8.26108 10L0 18.2611L1.73892 20L10 11.7389L18.2611 20L20 18.2611L11.7389 10L20 1.73892Z"
      fill="currentColor"
    />
  </svg>
);

export const LogoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="75"
      height="16"
      viewBox="0 0 75 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Vector"
        d="M10.648 9.99178C10.648 10.8246 10.5438 11.6035 10.3353 12.3282C10.1269 13.0525 9.79686 13.6839 9.34395 14.2223C8.89147 14.7606 8.30612 15.1879 7.58746 15.5036C6.86836 15.8192 6.00683 15.9775 5.00026 15.9775C4.22428 15.9775 3.42701 15.9126 2.6076 15.7829C1.78906 15.6532 1.04869 15.4387 0.388644 15.1373C0.215817 15.0655 0.108125 14.9795 0.0651358 14.8787C0.0217119 14.7779 0 14.6495 0 14.4908V0.430703C0.00173696 0.258595 0.0377788 0.143568 0.110297 0.0864865C0.179775 0.0281081 0.302664 0 0.475057 0H2.69532C2.85338 0 2.96889 0.0250811 3.04011 0.0752432C3.11176 0.125405 3.1478 0.243892 3.1478 0.430703V4.47914C3.52124 4.36411 3.93073 4.27805 4.37669 4.22054C4.82179 4.16303 5.25993 4.13405 5.6907 4.13405C6.56786 4.13405 7.3191 4.28541 7.94353 4.58681C8.56884 4.88822 9.08211 5.30119 9.48421 5.82487C9.88632 6.34897 10.1812 6.96995 10.3679 7.68778C10.5546 8.40562 10.648 9.17362 10.648 9.99178ZM7.39378 10.0566C7.39378 8.96519 7.18535 8.15395 6.76848 7.62292C6.35161 7.09189 5.7706 6.82595 5.02284 6.82595C4.83612 6.82595 4.56342 6.84324 4.2043 6.87957C3.84518 6.91416 3.49302 6.98984 3.14823 7.10443V13.0915C3.4357 13.1779 3.73749 13.235 4.05319 13.2636C4.36931 13.2921 4.62768 13.3068 4.82917 13.3068C5.61948 13.3068 6.24479 13.0629 6.70421 12.5747C7.16451 12.0869 7.39378 11.248 7.39378 10.0566ZM23.4706 10.035C23.4706 11.9291 23.0181 13.3937 22.1127 14.4277C21.2069 15.4612 19.8273 15.9779 17.9744 15.9779C16.1072 15.9779 14.7415 15.4603 13.8796 14.4268C13.0172 13.3933 12.5855 11.9434 12.5855 10.0765C12.5855 9.15805 12.7115 8.32951 12.9633 7.59005C13.2152 6.85059 13.5739 6.22919 14.0402 5.72627C14.5066 5.22335 15.075 4.83676 15.7425 4.56389C16.4112 4.29146 17.1694 4.15481 18.017 4.15481C19.8269 4.15481 21.1882 4.67459 22.1006 5.71589C23.0125 6.75632 23.4684 8.19546 23.4684 10.0333L23.4706 10.035ZM20.2164 10.099C20.2164 9.61038 20.1804 9.16584 20.1087 8.76411C20.0371 8.36195 19.9146 8.01773 19.7422 7.7306C19.5698 7.44346 19.3471 7.2173 19.0735 7.05168C18.8008 6.88735 18.4634 6.80432 18.0609 6.80432C17.2992 6.80432 16.7356 7.09492 16.3691 7.67654C16.0026 8.25816 15.8193 9.04389 15.8193 10.0346C15.8193 11.1114 15.9887 11.9295 16.3256 12.4895C16.6635 13.0495 17.2202 13.3293 17.9957 13.3293C18.3978 13.3293 18.7391 13.2471 19.0192 13.0815C19.2993 12.9172 19.5295 12.688 19.7088 12.3931C19.8886 12.099 20.0171 11.7574 20.0966 11.3704C20.1756 10.9829 20.2151 10.5591 20.2151 10.0999L20.2164 10.099ZM34.3752 12.5107C34.3752 13.6739 33.9627 14.5431 33.1359 15.1174C32.31 15.6917 31.2287 15.9788 29.8921 15.9788C29.1452 15.9788 28.3593 15.8958 27.5329 15.7306C26.7079 15.5654 25.9783 15.2964 25.3465 14.9232C25.2314 14.8506 25.1633 14.7762 25.1424 14.6962C25.1207 14.6171 25.1455 14.5059 25.2176 14.3624L25.8429 12.8765C25.9141 12.7187 25.9896 12.6214 26.0687 12.5859C26.1477 12.5501 26.2662 12.5686 26.4247 12.6396C26.654 12.739 26.9128 12.8363 27.2003 12.9293C27.4878 13.0231 27.7856 13.1057 28.0948 13.1775C28.4031 13.2493 28.7019 13.3072 28.9893 13.3496C29.2768 13.3929 29.5352 13.4145 29.7653 13.4145C30.2821 13.4145 30.646 13.3245 30.854 13.1451C31.0624 12.9652 31.1666 12.7386 31.1666 12.4662C31.1666 12.179 31.019 11.9351 30.725 11.7341C30.4297 11.533 29.9234 11.296 29.2052 11.0236C28.6307 10.8082 28.1239 10.5855 27.6853 10.3559C27.2476 10.1267 26.8776 9.87892 26.5759 9.61341C26.2741 9.34789 26.0443 9.04692 25.8863 8.70876C25.7282 8.37146 25.6492 7.98097 25.6492 7.536C25.6492 7.06205 25.736 6.62097 25.9089 6.21146C26.0813 5.80238 26.3401 5.44692 26.6848 5.14551C27.0296 4.84368 27.4643 4.60324 27.9889 4.42335C28.5134 4.24432 29.1353 4.15524 29.8531 4.15524C30.5001 4.15524 31.1575 4.21578 31.8245 4.33773C32.4932 4.45968 33.1003 4.64259 33.6466 4.88692C33.8046 4.9587 33.8906 5.03395 33.9054 5.11308C33.9201 5.19222 33.8984 5.31762 33.8411 5.4893L33.3026 6.86789C33.2449 7.02573 33.1802 7.11568 33.1081 7.13687C33.0365 7.15849 32.9214 7.14032 32.7633 7.08324C32.2318 6.92627 31.7429 6.80432 31.2978 6.71784C30.8522 6.63135 30.3928 6.58811 29.9186 6.58811C29.5308 6.58811 29.2499 6.67805 29.0779 6.85751C28.9055 7.03697 28.8191 7.21989 28.8191 7.4067C28.8191 7.69384 28.952 7.93081 29.2178 8.11719C29.4835 8.30443 29.9473 8.51935 30.6073 8.76368C31.1249 8.96476 31.6135 9.1693 32.0733 9.37773C32.5336 9.5853 32.9322 9.82962 33.2696 10.1094C33.6075 10.3892 33.8767 10.7235 34.0773 11.1109C34.2788 11.4984 34.3796 11.965 34.3796 12.5107H34.3752ZM45.0862 12.5107C45.0862 13.6739 44.6736 14.5431 43.8468 15.1174C43.0209 15.6917 41.9397 15.9788 40.6031 15.9788C39.8562 15.9788 39.0702 15.8958 38.2439 15.7306C37.4179 15.5654 36.6884 15.2964 36.0566 14.9232C35.9415 14.8506 35.8733 14.7762 35.8525 14.6962C35.8308 14.6171 35.8555 14.5059 35.9276 14.3624L36.5529 12.8765C36.6241 12.7187 36.6997 12.6214 36.7787 12.5859C36.8578 12.5501 36.9763 12.5686 37.1348 12.6396C37.3641 12.739 37.6229 12.8363 37.9104 12.9293C38.197 13.0231 38.4948 13.1057 38.8049 13.1775C39.1132 13.2493 39.4111 13.3072 39.6994 13.3496C39.986 13.3929 40.2444 13.4145 40.4745 13.4145C40.9913 13.4145 41.3547 13.3245 41.5627 13.1451C41.7712 12.9652 41.8754 12.7386 41.8754 12.4662C41.8754 12.179 41.7277 11.9351 41.4342 11.7341C41.1398 11.533 40.633 11.296 39.9144 11.0236C39.3403 10.8082 38.8331 10.5855 38.3954 10.3559C37.9568 10.1267 37.5877 9.87892 37.2855 9.61341C36.9841 9.34789 36.7544 9.04692 36.5963 8.70876C36.4383 8.37146 36.3593 7.98097 36.3593 7.536C36.3593 7.06205 36.4461 6.62097 36.6181 6.21146C36.7905 5.80238 37.0493 5.44692 37.394 5.14551C37.7388 4.84368 38.1735 4.60324 38.6981 4.42335C39.2226 4.24432 39.8445 4.15524 40.5622 4.15524C41.2093 4.15524 41.8663 4.21578 42.5337 4.33773C43.2024 4.45968 43.8091 4.64259 44.3553 4.88692C44.5143 4.9587 44.6002 5.03395 44.615 5.11308C44.6293 5.19222 44.6076 5.31762 44.5499 5.4893L44.0114 6.86789C43.9541 7.02573 43.8898 7.11568 43.8173 7.13687C43.7461 7.15849 43.6306 7.14032 43.473 7.08324C42.9414 6.92627 42.4525 6.80432 42.0074 6.71784C41.5623 6.63135 41.1029 6.58811 40.6287 6.58811C40.2409 6.58811 39.96 6.67805 39.788 6.85751C39.6156 7.03697 39.5292 7.21989 39.5292 7.4067C39.5292 7.69384 39.6621 7.93081 39.9278 8.11719C40.194 8.30443 40.6573 8.51935 41.3183 8.76368C41.835 8.96476 42.324 9.1693 42.7838 9.37773C43.2441 9.5853 43.6419 9.82962 43.9793 10.1094C44.318 10.3892 44.5872 10.7235 44.7878 11.1109C44.9889 11.4984 45.0896 11.965 45.0896 12.5107H45.0862ZM51.0991 14.0618C51.0991 14.6076 50.9097 15.0668 50.5289 15.44C50.1481 15.8132 49.6774 16 49.1172 16C48.8436 16 48.5852 15.9494 48.3408 15.8486C48.0963 15.7492 47.8848 15.6117 47.7046 15.4396C47.5248 15.2675 47.3815 15.0634 47.2734 14.8255C47.1662 14.589 47.1127 14.3343 47.1127 14.0614C47.1127 13.7885 47.1662 13.5338 47.2734 13.2969C47.3807 13.0599 47.5253 12.8558 47.705 12.6828C47.8848 12.5107 48.0967 12.3741 48.3408 12.2737C48.5848 12.1734 48.8436 12.1224 49.1168 12.1224C49.6769 12.1224 50.1476 12.3096 50.528 12.6828C50.9093 13.0556 51.0995 13.5152 51.0995 14.0605L51.0991 14.0618ZM63.2968 14.3416C63.2968 14.5284 63.2725 14.6863 63.2221 14.8156C63.1718 14.9444 63.0463 15.0664 62.8443 15.1814C62.5143 15.3392 62.1583 15.4685 61.7779 15.5689C61.3975 15.6692 61.0093 15.7483 60.6141 15.8058C60.2189 15.8634 59.8207 15.9062 59.4186 15.9356C59.0161 15.9637 58.6353 15.9788 58.2766 15.9788C57.2996 15.9788 56.4919 15.885 55.8518 15.6986C55.2126 15.5118 54.6989 15.2575 54.3111 14.9341C53.9233 14.611 53.6502 14.2305 53.4921 13.7924C53.3341 13.3548 53.2551 12.8843 53.2551 12.3827C53.2551 11.8223 53.3484 11.309 53.5351 10.8424C53.7219 10.3754 54.0019 9.97016 54.3758 9.62551C54.7493 9.28087 55.22 9.01146 55.7871 8.81816C56.3551 8.6253 57.0268 8.52843 57.802 8.52843H60.1729V8.18378C60.1729 7.9827 60.1512 7.78897 60.1078 7.60216C60.0652 7.41535 59.9753 7.25405 59.8385 7.11784C59.7026 6.98162 59.512 6.87005 59.268 6.784C59.0248 6.69751 58.7008 6.65427 58.2987 6.65427C58.0834 6.65427 57.8384 6.66551 57.5662 6.68714C57.2935 6.70876 57.0208 6.73773 56.7476 6.77362C56.4745 6.80951 56.2092 6.85276 55.9504 6.90335C55.6911 6.95308 55.4614 7.00714 55.2599 7.06422C55.0732 7.10746 54.9442 7.10746 54.8726 7.06422C54.8009 7.02097 54.751 6.928 54.7219 6.78443L54.3776 5.27697C54.3341 5.11914 54.3307 5.008 54.3667 4.94314C54.4027 4.87827 54.4779 4.82465 54.5925 4.78184C55.2395 4.55265 55.9182 4.38703 56.6291 4.2867C57.3412 4.18595 58.0482 4.13535 58.7525 4.13535C60.3179 4.13535 61.4674 4.46919 62.2004 5.13686C62.9329 5.80454 63.299 6.79135 63.299 8.09773V14.3421L63.2968 14.3416ZM60.1512 10.6162H58.449C58.2475 10.6162 58.0321 10.6301 57.802 10.6595C57.5718 10.6876 57.3603 10.7559 57.1662 10.8636C56.9726 10.9717 56.811 11.1261 56.6816 11.3271C56.5522 11.5282 56.4875 11.8011 56.4875 12.1453C56.4875 12.6478 56.6569 12.9994 56.9934 13.2004C57.3312 13.4015 57.7872 13.5018 58.3613 13.5018C58.4481 13.5018 58.5628 13.4988 58.7065 13.4915C58.8502 13.4841 59.0048 13.4698 59.1698 13.4482C59.3348 13.4266 59.5042 13.3976 59.6761 13.3617C59.849 13.3258 60.007 13.2796 60.1508 13.2216L60.1512 10.6162ZM74.891 6.04973C74.891 6.26595 74.8593 6.47784 74.7946 6.68541C74.7295 6.89297 74.6187 7.09103 74.4602 7.27784L69.2885 13.0915L69.3319 13.1996H74.5905C74.7481 13.1996 74.8554 13.2242 74.9131 13.2744C74.9713 13.3245 75 13.4288 75 13.5866V15.3302C75 15.488 74.9752 15.5957 74.9249 15.6532C74.8745 15.7103 74.7703 15.7397 74.6122 15.7397H66.2275C65.8684 15.7397 65.6065 15.6562 65.4415 15.491C65.2765 15.3258 65.1931 15.0997 65.1931 14.8121V14.1665C65.1931 13.9511 65.2253 13.7358 65.29 13.5204C65.3551 13.3042 65.4954 13.075 65.7112 12.8307L70.8613 7.01665L70.8178 6.93016H66.1207C65.9483 6.93016 65.8406 6.90205 65.7976 6.84454C65.7542 6.78703 65.7325 6.67935 65.7325 6.52151V4.84324C65.7325 4.57081 65.8688 4.43459 66.142 4.43459H73.8141C74.1736 4.43459 74.4437 4.48822 74.6218 4.59589C74.8024 4.704 74.891 4.93665 74.891 5.29557V6.04973Z"
        fill="var(--textAndLabels-main)"
      />
    </svg>
  );
};

export const NoInernetIcon = () => {
  return (
    <svg
      width="290"
      height="290"
      viewBox="0 0 290 290"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M168.91 137.54C151.068 131.785 146.79 113.775 146.79 113.775C147.389 112.919 147.974 112.053 148.545 111.178L149.122 101.887C139.802 99.3098 145.092 87.9611 145.092 87.9611C140.818 81.7145 137.251 75.0128 134.456 67.979C129.281 68.4832 124.324 70.3144 120.065 73.2955C123.627 85.1881 129.643 99.871 142.427 119.433C136.926 126.301 127.946 137.159 123.621 142.806L89.1394 127.368L81.2793 143.625L119.983 163.443C122.656 164.693 125.681 164.972 128.538 164.232C131.395 163.491 133.904 161.778 135.633 159.386L144.104 147.708C147.503 152.917 150.107 157.193 159.541 161.14C169.577 156.624 173.923 151.155 177.687 143.625C174.43 142.123 171.46 140.063 168.91 137.54Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M169.377 207.793L167.979 200.145L200.651 194.116L202.049 201.762L169.377 207.793Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M197.966 201.351L192.84 195.541L220.443 171.2L225.567 177.01L197.966 201.351Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M72.48 85.1028C71.906 85.0865 71.3343 85.1835 70.7977 85.3881C70.2611 85.5927 69.77 85.9011 69.3526 86.2955C68.9351 86.6899 68.5994 87.1627 68.3647 87.6868C68.1299 88.211 68.0007 88.7762 67.9844 89.3503C67.9681 89.9244 68.0651 90.496 68.2697 91.0326C68.4743 91.5693 68.7827 92.0603 69.1771 92.4778C69.5715 92.8952 70.0443 93.2309 70.5684 93.4657C71.0926 93.7004 71.6578 93.8296 72.2319 93.8459C73.3913 93.8788 74.5163 93.4498 75.3594 92.6532C76.2025 91.8567 76.6946 90.7578 76.7275 89.5984C76.7604 88.439 76.3314 87.314 75.5348 86.471C74.7383 85.6279 73.6394 85.1357 72.48 85.1028Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M76.0436 64.9836C77.2135 63.2072 77.929 61.1705 78.1273 59.0527C78.3256 56.9348 78.0006 54.8007 77.1808 52.838C76.3611 50.8752 75.0717 49.1439 73.426 47.7962C71.7803 46.4485 69.8288 45.5258 67.7429 45.109C65.6571 44.6923 63.5008 44.7944 61.4636 45.4063C59.4265 46.0183 57.5708 47.1213 56.0598 48.6184C54.5489 50.1156 53.4288 51.961 52.7982 53.9924C52.1675 56.0239 52.0456 58.1791 52.4431 60.2687C52.4763 60.4909 52.521 60.7102 52.5802 60.9266L58.8835 59.7493C58.6228 58.89 58.5403 57.9866 58.641 57.0943C58.7418 56.2019 59.0236 55.3396 59.4694 54.5601C59.9151 53.7805 60.5153 53.1002 61.2332 52.5608C61.9511 52.0213 62.7715 51.6342 63.6443 51.423C64.5171 51.2118 65.4238 51.181 66.3089 51.3326C67.194 51.4841 68.0389 51.8148 68.7917 52.3043C69.5445 52.7939 70.1894 53.432 70.6869 54.1795C71.1844 54.9271 71.5241 55.7683 71.6851 56.6518C72.2622 59.7984 70.5525 62.2136 68.423 64.8754C67.0249 66.5423 66.2587 68.6483 66.2589 70.8239C66.2675 74.073 66.6542 77.3119 67.4131 80.4716L73.9055 79.238C73.2089 76.3316 72.9046 73.345 73.0009 70.3579C73.412 68.2731 74.9197 66.6832 76.0436 64.9836Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3854 11.5486C69.9117 10.2615 80.5898 11.864 90.2746 16.1841C108.909 24.4857 120.356 40.6763 123.771 58.3629C123.771 58.3629 123.855 60.7464 124.035 62.583C122.897 63.2697 120.656 61.361 118.698 59.6917C116.932 58.1869 115.396 56.8783 115.107 57.8493C114.83 58.7828 115.497 59.7826 116.556 61.3696C117.977 63.4991 120.102 66.6847 121.6 72.1859L120.157 73.3589C120.594 75.1075 121.628 78.0478 122.845 81.5104L123.344 82.9344C120.923 93.403 115.563 103.372 107.094 111.525C99.8608 118.522 90.9426 123.531 81.2041 126.068C80.9877 126.126 79.5132 125.168 77.7602 124.03C75.3638 122.472 72.4466 120.577 71.5088 120.473C70.0213 120.307 73.5387 124.845 75.058 126.807C75.1965 126.983 75.3176 127.139 75.4158 127.269C67.7514 128.466 59.9253 128.125 52.3941 126.266C44.8628 124.407 37.7773 121.066 31.5509 116.439C25.3245 111.812 20.0819 105.992 16.1291 99.3172C12.1762 92.6425 9.5922 85.2475 8.52785 77.5635C7.46351 69.8795 7.94012 62.0605 9.92989 54.5627C11.9197 47.0648 15.3827 40.0384 20.117 33.8932C24.8514 27.7481 30.7621 22.6074 37.5044 18.771C44.2467 14.9346 51.6841 12.4794 59.3854 11.5486ZM60.9233 24.0529C69.158 23.0457 77.5115 24.2991 85.088 27.6785C114.941 40.9778 121.207 80.16 98.2458 102.261C93.0363 107.301 86.7026 111.03 79.7678 113.139C72.8331 115.248 65.4961 115.677 58.3626 114.391C51.2292 113.105 44.504 110.141 38.7422 105.743C32.9804 101.345 28.3473 95.64 25.2255 89.0983C22.1037 82.5566 20.5827 75.3662 20.7881 68.1207C20.9935 60.8752 22.9193 53.7825 26.4067 47.4281C29.894 41.0738 34.8428 35.6401 40.8445 31.5756C46.8462 27.5112 53.7285 24.9327 60.9233 24.0529Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M225.65 187.619L228.994 182.548L223.841 178.491L221.128 180.93L225.65 187.619Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M243.358 193.765L239.03 203.72C237.724 206.753 235.475 209.283 232.615 210.934L254.216 227.775L266.935 212.097L243.358 193.765Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M220.58 117.886C224.179 118.389 227.834 117.476 230.773 115.339C233.713 113.202 235.709 110.007 236.341 106.428C231.904 105.001 227.228 104.477 222.586 104.887C217.944 105.296 213.431 106.631 209.313 108.813C210.199 111.2 211.714 113.304 213.697 114.901C215.68 116.499 218.058 117.53 220.58 117.886Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M137.991 112.404L118.037 96.8901C115.168 102.971 111.016 108.359 105.867 112.682L131.548 132.939L142.458 119.426L137.991 112.404Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M148.956 104.729L152.875 101.962C151.632 102.043 150.385 102.015 149.148 101.879L148.956 104.729Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M175.022 119.01C175.311 116.8 174.809 114.559 173.605 112.683C172.402 110.807 170.574 109.417 168.445 108.758C168.717 107.975 168.802 107.14 168.692 106.318C166.882 93.107 164.141 84.9656 159.618 80.307C156.548 77.0983 150.272 77.6206 146.544 82.3066C142.842 86.9999 143.772 93.1907 143.748 93.7043C144.123 89.0926 146.276 84.8072 149.751 81.7526C150.724 80.954 151.868 80.3911 153.094 80.1079C152.902 84.276 156.219 90.8809 160.221 89.2361C162.897 88.144 163.219 92.9873 157.946 92.9873C156.521 104.417 156.959 117.514 162.222 128.183L163.072 129.799C165.659 134.511 169.357 138.519 173.845 141.477C176.826 141.632 179.746 140.598 181.964 138.6C184.182 136.603 185.516 133.807 185.673 130.826C185.828 127.846 184.793 124.926 182.796 122.708C180.799 120.49 178.003 119.167 175.022 119.01Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M225.65 187.619L228.994 182.548L223.84 178.491L221.128 180.93L225.65 187.619Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinejoin="round"
      />
      <path
        d="M243.358 193.765L239.03 203.72C237.724 206.753 235.475 209.283 232.615 210.934L254.216 227.775L266.935 212.097L243.358 193.765Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
      />
      <path
        d="M137.991 112.404L118.036 96.8901C115.168 102.971 111.016 108.359 105.867 112.682L131.548 132.939L142.458 119.426L137.991 112.404Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
      />
      <path
        d="M144.68 87.3781C140.54 81.3261 137.118 74.8136 134.482 67.9717C129.306 68.4739 124.349 70.308 120.092 73.2954C123.656 85.1909 129.658 99.8565 142.455 119.427"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.478 65.011C123.71 61.0121 123.415 56.9366 123.601 52.8688C123.519 50.7669 123.664 48.6622 124.034 46.5914C125.044 40.9113 126.427 41.4653 126.885 46.9477C128.003 60.3769 131.213 64.8191 132.393 68.273"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.791 48.3184C122.872 46.38 121.682 44.5826 120.255 42.9803C119.822 42.5648 118.813 42.5229 120.063 45.9956C120.332 46.7372 121.404 49.943 121.736 51.0943C122.505 53.3911 123.128 55.7346 123.6 58.1104"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.985 61.8039C123.793 64.5177 119.602 60.3207 117.625 58.7337C115.846 57.3054 113.297 56.3979 116.885 61.5846C119.011 64.8937 120.62 68.5081 121.655 72.3028"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.596 190.47L221.128 180.93"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.184 101.809C149.184 101.809 148.881 105.606 148.579 111.171C147.974 112.029 147.38 112.894 146.798 113.768"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.876 102.044L148.968 104.696"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.211 194.307L172.31 170.159"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.437 179.998C201.928 166.322 189.57 155.462 174.914 148.779"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.258 199.725L159.618 161.113"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.391 198.336L202.049 201.762L169.377 207.793L167.979 200.145L192.84 195.568"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.817 141.515C176.754 141.593 179.605 140.521 181.763 138.529C183.921 136.537 185.217 133.781 185.374 130.847C185.531 127.914 184.537 125.036 182.604 122.824C180.67 120.613 177.95 119.244 175.022 119.008C175.311 116.798 174.809 114.557 173.605 112.681C172.402 110.805 170.574 109.414 168.445 108.755C169.332 106.183 166.588 90.0171 161.646 82.8004C157.009 76.0282 150.231 77.6137 146.516 82.3041C142.801 86.9945 143.745 93.1868 143.72 93.7018"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.65 187.619L244.317 159.221C247.879 153.492 247.742 151.683 249.332 147.737C256.788 143.68 273.7 138.91 282.061 137.814C275.921 147.408 261.531 153.081 255.856 164.978L238.999 203.681C238.003 205.974 236.467 207.991 234.521 209.56C232.575 211.128 230.278 212.202 227.827 212.69C225.375 213.177 222.842 213.063 220.444 212.359C218.046 211.654 215.854 210.379 214.056 208.643L202.433 197.433"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.966 201.351L192.84 195.541L220.443 171.201L225.567 177.011L197.966 201.351Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.0267 129.535C78.0146 129.234 73.0472 124.496 72.2306 123.043C71.1269 121.074 69.9568 118.793 75.1089 122.412C79.2828 125.047 83.6122 127.427 88.0735 129.538"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M174.64 206.806L176.914 214.975C178.397 220.224 181.868 224.688 186.59 227.419C191.305 230.16 234.367 250.827 234.367 250.827C245.852 257.32 250.539 272.043 259.694 278.841C259.173 270.426 255.555 253.212 252.019 245.514C248.246 243.681 246.409 243.674 241.165 239.923L200.021 211.005L197.665 202.562"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.971 134.195C152.41 136.224 143.048 149.178 135.634 159.413C133.902 161.802 131.393 163.514 128.537 164.253C125.681 164.993 122.656 164.715 119.983 163.467L81.2795 143.652L89.118 127.398L123.6 142.803"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M168.911 137.54C171.477 140.054 174.447 142.122 177.695 143.658C174.06 152.026 167.839 157.444 159.563 161.167C150.103 157.207 147.513 152.971 144.098 147.74"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.853 172.571C201.872 149.81 183.878 146.208 177.696 143.658"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.791 113.775C146.791 113.775 151.067 131.783 168.911 137.54C166.159 134.826 163.888 131.665 162.195 128.192C156.919 117.537 156.493 104.427 157.918 92.9976H158.631C162.959 92.7509 162.879 88.1428 160.194 89.2465C156.19 90.8869 152.876 84.2848 153.068 80.1196C151.842 80.405 150.698 80.9671 149.724 81.7629C147.697 83.5378 146.107 85.7569 145.079 88.2472C144.05 90.7375 143.611 93.4318 143.795 96.1197C144.306 99.604 146.705 102.388 152.876 102.048"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.79 113.775C144.214 117.67 124.122 141.487 121.436 145.846"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.8047 132.66C63.4889 132.825 60.7766 133.374 59.9802 133.537C56.3632 134.282 56.8292 135.237 57.4048 135.292C59.7334 135.512 63.5163 135.485 65.6819 135.758C69.1633 136.198 75.8793 136.827 78.5108 138.389"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.49 135.73C64.9129 135.95 64.3935 136.142 64.1468 136.251C60.6928 137.567 61.3247 138.451 61.899 138.415C64.2304 138.278 67.9585 137.594 70.1501 137.511C72.7857 137.462 75.42 137.664 78.0174 138.114"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M165.621 56.981C165.579 57.6862 165.328 58.363 164.9 58.9253C164.472 59.4877 163.887 59.9102 163.219 60.1392C162.72 60.3107 162.189 60.3695 161.664 60.3112C161.139 60.2528 160.634 60.0789 160.185 59.8019C159.735 59.5248 159.353 59.1516 159.065 58.709C158.777 58.2665 158.591 57.7656 158.52 57.2425C158.449 56.7194 158.495 56.187 158.654 55.6837C158.814 55.1805 159.083 54.7188 159.442 54.332C159.801 53.9452 160.242 53.6429 160.732 53.4468C161.222 53.2507 161.75 53.1658 162.277 53.1981C163.22 53.2601 164.101 53.6924 164.728 54.401C165.354 55.1095 165.675 56.0368 165.621 56.981Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M260.38 143.214C261.176 135.49 259.374 127.721 255.257 121.136C251.141 114.552 244.946 109.529 237.653 106.862C231.593 104.647 225.037 104.156 218.714 105.444C212.391 106.732 206.549 109.747 201.837 114.156C197.126 118.565 193.729 124.194 192.024 130.417C190.32 136.64 190.374 143.215 192.182 149.409"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.292 174.432C227.215 174.711 231.155 174.311 234.942 173.253"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M224.471 90.0646C222.417 89.7814 220.325 89.957 218.347 90.5786C216.369 91.2003 214.553 92.2526 213.03 93.6599C211.507 95.0672 210.314 96.7945 209.539 98.7176C208.763 100.641 208.423 102.712 208.543 104.782C208.706 107.551 209.686 110.209 211.359 112.422C213.032 114.634 215.323 116.301 217.942 117.212C220.562 118.123 223.393 118.238 226.078 117.541C228.763 116.844 231.181 115.367 233.027 113.297C234.872 111.226 236.062 108.655 236.446 105.907C236.955 102.219 235.979 98.4799 233.734 95.5098C231.489 92.5397 228.158 90.5814 224.471 90.0646Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.834 48.2353C117.338 39.3196 111.706 31.3993 104.431 25.1709C97.1568 18.9425 88.4635 14.5968 79.1158 12.5161C69.768 10.4353 60.0522 10.6831 50.8227 13.2378C41.5932 15.7924 33.1328 20.5757 26.1854 27.1668C19.238 33.758 14.0165 41.9552 10.98 51.0376C7.94349 60.1199 7.18506 69.8093 8.77137 79.2535C10.3577 88.6977 14.2402 97.6075 20.0774 105.199C25.9146 112.791 33.5277 118.833 42.2473 122.792C52.6373 127.427 64.138 128.987 75.3873 127.288"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.301 82.8276C121.525 90.5072 118.209 97.7464 113.554 104.107C108.898 110.468 103.001 115.818 96.2178 119.833C91.5307 122.6 86.4737 124.686 81.1987 126.028"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.0883 27.6784C77.512 24.2989 69.1588 23.0454 60.9243 24.0522C52.6898 25.0591 44.8847 28.2884 38.3459 33.3939C31.8072 38.4993 26.7815 45.2883 23.8077 53.0327C20.8339 60.7772 20.0242 69.1851 21.4655 77.3548C22.9068 85.5244 26.5447 93.1477 31.989 99.407C37.4333 105.666 44.4788 110.326 52.3698 112.886C60.2608 115.445 68.6998 115.809 76.7817 113.937C84.8636 112.066 92.2837 108.029 98.2461 102.261C121.208 80.1598 114.942 40.9776 85.0883 27.6784Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4795 165.307L55.6505 174.954L68.0668 155.904"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M150.053 173.777L138.21 175.284"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.871 180.464L143.364 168.596"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.729 89.5984C76.7047 90.4633 76.4245 91.3015 75.9237 92.0071C75.423 92.7127 74.7243 93.254 73.9159 93.5625C73.1076 93.8709 72.2259 93.9327 71.3824 93.7401C70.5389 93.5475 69.7715 93.109 69.1772 92.4802C68.5829 91.8514 68.1884 91.0605 68.0436 90.2075C67.8988 89.3544 68.0103 88.4777 68.3638 87.688C68.7174 86.8983 69.2972 86.2312 70.0299 85.771C70.7626 85.3109 71.6153 85.0783 72.4801 85.1028C73.6387 85.1387 74.7359 85.6317 75.5321 86.474C76.3282 87.3164 76.7586 88.4397 76.729 89.5984Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.0163 64.9836C77.1861 63.2072 77.9017 61.1705 78.1 59.0527C78.2983 56.9348 77.9732 54.8007 77.1535 52.838C76.3337 50.8752 75.0443 49.1439 73.3987 47.7962C71.753 46.4485 69.8014 45.5258 67.7156 45.109C65.6297 44.6923 63.4734 44.7944 61.4363 45.4063C59.3991 46.0183 57.5435 47.1213 56.0325 48.6184C54.5215 50.1156 53.4015 51.961 52.7708 53.9924C52.1402 56.0239 52.0183 58.1791 52.4158 60.2687C52.4475 60.4909 52.4937 60.7102 52.5528 60.9266L58.8576 59.7493C58.595 58.8896 58.511 57.9852 58.6105 57.0917C58.7101 56.1983 58.9913 55.3346 59.4368 54.5537C59.8823 53.7729 60.4827 53.0913 61.2012 52.551C61.9196 52.0106 62.7409 51.6227 63.6147 51.4113C64.4885 51.1998 65.3962 51.1692 66.2823 51.3213C67.1683 51.4734 68.0139 51.8051 68.7671 52.2958C69.5203 52.7866 70.1653 53.4261 70.6624 54.1752C71.1594 54.9243 71.4982 55.767 71.6577 56.6518C72.2348 59.7984 70.5252 62.2136 68.3957 64.8754C66.9976 66.5423 66.2314 68.6483 66.2315 70.8239C66.1998 71.9925 66.2517 73.1626 66.3845 74.3254C66.5446 75.8548 67.4103 80.4716 67.4103 80.4716L73.9026 79.238C73.8204 79.238 73.0254 74.0859 72.9706 73.5103C72.8199 72.4649 72.8199 71.4033 72.9706 70.3579C73.3847 68.2731 74.8924 66.6832 76.0163 64.9836Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.6211 140.857C78.7829 138.322 74.7182 136.149 70.479 134.364C67.0756 133.12 63.5424 132.265 59.9469 131.815C54.6563 131.166 54.0518 129.742 59.8098 128.964C61.9285 128.707 64.064 128.616 66.1969 128.69C70.2409 128.742 74.2676 129.238 78.2034 130.17"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
